/*!
 * lhx-rail-recs.js — suplente de `<product-recommendations>` para temas que NO son Horizon.
 *
 * POR QUÉ EXISTE (08/09/2026, al llevar el rail a las fichas de Simplit).
 * En modo «recomendados» la sección `lhx-video-rail` no pinta nada por sí misma: envuelve el
 * cuerpo en `<product-recommendations>` y deja que el componente NATIVO de Horizon pida los
 * relacionados y haga el morph. El tema de Simplit no es Horizon: ese elemento no está definido,
 * así que es un `<div>` cualquiera.
 *
 * 🩸 Y falla EN SILENCIO, que es lo caro: el rail sale vacío, sin un solo error en consola.
 *    Medido en la ficha del Sartén Copper: Shopify devolvía 10 relacionados y 9 con video —el
 *    dato estaba— y la sección igual quedaba en blanco porque nadie los fue a buscar.
 *
 * QUÉ HACE. Si el navegador YA conoce `product-recommendations` (Horizon), no hace nada: se
 * desactiva solo. Si no, pide la sección renderizada con `section_id` —el patrón estándar de
 * Shopify, no un invento— y reemplaza el contenido.
 *
 * 🪤 Carga perezosa con IntersectionObserver, igual que el componente nativo: el rail va abajo
 *    en la ficha y no tiene por qué costar en la primera pantalla.
 * 🪤 Si vuelve sin tarjetas (ningún relacionado con video subido), se OCULTA la sección entera.
 *    Un título «Míralos en movimiento» sobre la nada se ve peor que no tener la sección.
 */
(function () {
  'use strict';
  if (window.__lhxRailRecs) return;
  window.__lhxRailRecs = true;

  /* Horizon lo define él mismo: ahí este archivo sobra y se aparta. */
  if (window.customElements && customElements.get('product-recommendations')) return;

  function hidratar(el) {
    if (el.dataset.lhxHecho) return;
    el.dataset.lhxHecho = '1';

    var url = el.getAttribute('data-url');
    var sid = el.getAttribute('data-section-id');
    var pid = el.getAttribute('data-product-id');
    if (!url || !sid || !pid) return;

    var u = url + (url.indexOf('?') < 0 ? '?' : '&') +
            'section_id=' + encodeURIComponent(sid) + '&product_id=' + encodeURIComponent(pid);

    fetch(u, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cuerpo = doc.querySelector('.lhx-rail');
        var seccion = el.closest('.shopify-section') || el.parentElement;
        /* sin tarjetas no hay rail: se oculta en vez de dejar un título huérfano */
        if (!cuerpo || !cuerpo.querySelector('[data-lhx-rail-item]')) {
          if (seccion) seccion.hidden = true;
          return;
        }
        el.innerHTML = cuerpo.outerHTML;
        el.setAttribute('data-recommendations-performed', 'true');
      })
      .catch(function () { /* que la ficha no se rompa por un rail */ });
  }

  function arrancar() {
    var els = document.querySelectorAll('product-recommendations[data-url*="recommendations"]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(hidratar);
      return;
    }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        hidratar(e.target);
      });
    }, { rootMargin: '400px' });   // el mismo adelanto que usa el componente nativo
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else { arrancar(); }
})();
